import { useSyncExternalStore } from 'react';

/** Which message is being edited (shared so the composer's ↑ key can start editing). */
let editingId: string | null = null;
const listeners = new Set<() => void>();

export const editingStore = {
  set(id: string | null) {
    editingId = id;
    listeners.forEach((listener) => listener());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const useEditingMessageId = () =>
  useSyncExternalStore(editingStore.subscribe, () => editingId);
